import React from "react";
import { Button, Drawer, Heading, Icon, Text } from "@telia/teddy";
import "./WirelessInfoDrawer.less";

interface WirelessInfoDrawerProps {
    onOpenChange: (open: boolean) => void;
    open: boolean;
}

const WirelessInfoDrawer: React.FC<WirelessInfoDrawerProps> = ({ open, onOpenChange }) => (
    <Drawer open={open} onOpenChange={onOpenChange}>
        <Drawer.Overlay>
            <Drawer.Content size="md">
                <Drawer.Close slot="floating" />
                <Drawer.Title className="wireless-info-drawer__title" variant="title-300">
                    Du kan få Trådløst Bredbånd
                </Drawer.Title>
                <div className="wireless-info-drawer__list">
                    <div className="wireless-info-drawer__item">
                        <Icon name="wireless" size="md" aria-hidden="true" focusable="false" />
                        <div>
                            <Heading as="h3" variant="title-100" mb="100">
                                Stabilt, sterkt nett
                            </Heading>
                            <Text as="p" variant="paragraph-100">
                                Få internett med god fart, perfekt for både jobb, strømming og gaming
                            </Text>
                        </div>
                    </div>
                    <div className="wireless-info-drawer__item">
                        <Icon name="home-installation" size="md" aria-hidden="true" focusable="false" />
                        <div>
                            <Heading as="h3" variant="title-100" mb="100">
                                Enkelt å komme i gang
                            </Heading>
                            <Text as="p" variant="paragraph-100">
                                Enkel montering helt uten å grave – gjør det selv eller bestill montør
                            </Text>
                        </div>
                    </div>
                    <div className="wireless-info-drawer__item">
                        <Icon name="tv" size="md" aria-hidden="true" focusable="false" />
                        <div>
                            <Heading as="h3" variant="title-100" mb="100">
                                Pakkepris med TV
                            </Heading>
                            <Text as="p" variant="paragraph-100">
                                Få rabatt hvis du ønsker Trådløst bredbånd sammen med Telia Play
                            </Text>
                        </div>
                    </div>
                </div>
                <Drawer.Footer className="wireless-info-drawer__footer">
                    <Button
                        className="wireless-info-drawer__button"
                        variant="primary"
                        onClick={() => onOpenChange(false)}
                    >
                        Lukk
                    </Button>
                </Drawer.Footer>
            </Drawer.Content>
        </Drawer.Overlay>
    </Drawer>
);

export default WirelessInfoDrawer;
